// How long, and since when, in words (Oct 2026, Chris's review H2). A turn timer had no upper
// bound: a table left open past midnight read "1441m over", and a dev-stack one "47301m over".
// And "since 21:31" read as tonight for a table seated a month ago.

/** 47 → "47m", 135 → "2h 15m", 120 → "2h", 1500 → "1d 1h", 47301 → "32d". */
export function duration(minutes) {
  const m = Math.max(0, Math.floor(Number(minutes) || 0));
  if (m < 60) return `${m}m`;
  if (m < 24 * 60) {
    const h = Math.floor(m / 60);
    const r = m % 60;
    return r ? `${h}h ${r}m` : `${h}h`;
  }
  const d = Math.floor(m / (24 * 60));
  const h = Math.floor((m % (24 * 60)) / 60);
  return d < 7 && h ? `${d}d ${h}h` : `${d}d`;
}

const hhmm = (d) => d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** When something started: "21:31" today, "yesterday 21:31", else "Mon 21 Sept 21:31". */
export function sinceWords(iso, now = new Date()) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  if (sameDay(d, now)) return hhmm(d);
  const y = new Date(now);
  y.setDate(y.getDate() - 1);
  if (sameDay(d, y)) return `yesterday ${hhmm(d)}`;
  return `${d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })} ${hhmm(d)}`;
}
